import { CLINIC_TZ } from '@/lib/clinic-time';
/** RL-1643: the clinic's calendar day (Malaysia) of an instant, YYYY-MM-DD. */
export function clinicDay(iso: string | Date): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: CLINIC_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(typeof iso === 'string' ? new Date(iso) : iso);
}

export const todayInClinic = () => clinicDay(new Date());
